import { Navbar } from '~/components/Navbar';
import { ReactNode } from 'react'
import { Footer } from '~/components/Footer';
import { UserData } from '~/dataType';

interface Props {
  user?: UserData | null;
  children?: ReactNode
}


export const Layout = ({ children, user = null }: Props) => {
  return (
    <div className="flex min-h-screen w-full flex-col">
      <Navbar user={user} />
      {children}
      <Footer />
    </div>
  );
}
